<template>
  <div>
    <ul class="policies_title">
      <li :class="curTab === item.id?'active':'item_title'" v-for="(item,index) in plateData" :key="item.id"
          @click="show(item.id)">
        {{item.plateName}}
        <ul class="policies_list" v-if="curTab === item.id">
           <li class="item_list" v-for="(target,index) in articleList" :key="target.articleId">
             <router-link :to="{path:'/articleDetail',query: {menuId: menuId,plateId:item.id,articleId:target.articleId}}">
          <p class="title_box">
            <img src="../assets/images/index/listMark.png" alt=""><span class="title">{{target.title}}</span></p>
              <span class="date">{{target.publishTime}}</span>
             </router-link>
           </li>
        </ul>
      </li>
     <router-link :to="{path:'/articleList',query:{menuId:menuId,plateId:plateData[0].id}}">
       <span class="more">更多>></span>
     </router-link>
    </ul>

  </div>
</template>

<script>
  import {queryArticleList} from '@/api/ArticleList.js'

  export default {
    props: {
      plateData: Array,
      menuId:Number
    },
    data() {
      return {
        curTab: this.plateData[0].id,
        articleList:[]
      }
    },
    created(){
      this.show()
      this.menu()
    },
    methods: {
      menu() {
        window.scrollTo(0,0)
      },
      show(id) {
//        this.curTab = id
        queryArticleList(this.menuId,id == undefined ? this.curTab : this.curTab = id,0,8).then((res)=>{
//          console.log(res)
          this.articleList = res.list
        })
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 // $themeColor: #3e76fc;
  div {
    .policies_title {
      /*min-width: 460px;*/
      width: 100%;
      display: flex;
      justify-content: space-around;
      font-size: 18px;
      margin-top: 10px;
      overflow: hidden;
      .item_title {
        min-width: 90px;
        color: $themeColor;
      }
      .active {
        background-color: $themeColor;
        color: #fff;
      }
      li {
        min-width: 90px;
        height: 30px;
        /*margin: 0 10px 0 15px;*/
        border-radius: 3px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        .policies_list {
          width: 100%;
          /*min-width: 470px;*/
          height: 390px;
          padding: 10px 0;
          position: absolute;
          top: 50px;
          left: 0;
          .item_list{
            /*min-width: 470px;*/
            width: 100%;
            height: 48px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            line-height: 48px;
            padding: 0 5px;
            border-bottom: 1px dashed #e6e6e6;

            a{
              width:100%;
              font-size: 16px;
              color: #333;
              display: flex;
              justify-content: space-between;
            }
            .title_box {
              /*min-width: 318px;*/
              width: 80%;
              padding-left: 15px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .title{
                margin-right: 20px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              img {
                /*width: 8px;*/
                height: 12px;
                margin-right: 10px;
              }
            }
            .date {
              color: #999;
            }
          }
          .item_list:hover{
            .title,.date{
              color: $themeColor;
            }
          }
        }
      }
      .more {
        width: 60px;
        height: 30px;
        display: inline-block;
        font-size: 14px;
        color: #999;
        line-height: 30px;
        text-align: center;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
      }
    }
  }
</style>
